import { Component } from '@angular/core'
import { DefaultRowComponent } from '../default-row/default-row.component'
import { CustomTableService } from '../../service/custom-table.service'
import { ICustomTableColumnButton } from '../../modals/interface/custom-table.interface'

@Component({
    selector: 'app-dispenser-shipment-history-row',
    templateUrl: './dispenser-shipment-history-row.component.html',
    styleUrls: ['./dispenser-shipment-history-row.component.scss'],
    standalone: false
})
export class DispenserShipmentHistoryRowComponent extends DefaultRowComponent {
  constructor(private customTableService: CustomTableService) {
    super()
  }

  public showOnCreditNote(btn: ICustomTableColumnButton): boolean {
    if (btn.key == 'downloadCreditNote') {
      const id = this.row[this.uid]
      const data = this.customTableService.dataSource[id]
      return data.type == 'CREDIT_NOTE' && data.orderDocument
    }
    return true
  }

  public onClick(control: any): void {
    this.customTableService.clicked(control, this.row)
  }
}
